<div [ngClass]="{'activate': showCard}" class="card uploaderBox">
  <div class="card-body card-front">
    <div class="card-title">
      <h4> <i class="fal fa-upload icon"></i> {{ cardTitle }} <div class="close" title="Close" (click)="closeCard()">&times;</div>
      </h4>
    </div>

    <form>
      <div class="form-group row pt-4">
        <h6 style="padding: 0;">Step 1: Choose an image type</h6>
        <div class="d-flex align-items-center">
          <label for="imgTypeDropdown" class="col-form-label me-2 img-data-label" style="white-space: nowrap;">Image type:</label>
          <select class="form-control" style="width: auto; min-width: 180px;" name="imgTypeDropdown" id="imgTypeDropdown"
            [(ngModel)]="batchTypeId"
            (change)="changedBatchType($event.target.value)" [disabled]="working">
            <option selected="true" [value]="-1" disabled>Choose an image type</option>
            <option *ngFor="let o of imageTypes" [ngValue]="o.uid">{{ o.typeOfImage }}</option>
          </select>
        </div>
      </div>
      <div class="form-group mt-2" *ngIf="step1Ready">
        <h6>Step 2: Choose source and call numbers </h6>
        <div class="col-auto">
          <app-source-call-no-filter #sourceCallNoFilter (userSelectionReady)="readSourceCallEmitted($event)" (changeSourceSelection)="changedSourceSelection($event)" [callNumberData]="callNumberData" [sourceData]="sourceData" *ngIf="step1Ready"></app-source-call-no-filter>
        </div>
      </div>
      <div class="form-group row" *ngIf="step1Ready && step2Ready">
        <h6 style="padding: 0;">Step 3: Name this upload batch (optional)</h6>
        <div class="d-flex align-items-center">
          <label for="uploadBatchName" class="col-form-label me-2 label" style="white-space: nowrap;">
        Upload batch name:
          </label>
          <input type="text" name="uploadBatchName" placeholder="optional" [(ngModel)]="batchUploadName" class="form-control" style="width: auto; min-width: 180px;" maxlength="150">
        </div>
      </div>
      <div *ngIf="!working && step1Ready && step2Ready">
        <h6>Step 4: Edit this upload batch (optional)</h6>
        <small class="notice">Edits will be applied on upload.</small>
        <button type="button" class="collapsible" (click)="toggleBatchEdit()" [ngClass]="{'edited': this.batchEdit}">Batch Edit<i class="fal" [ngClass]="{'fa-chevron-double-down': !batchEditOpen, 'fa-chevron-double-up': batchEditOpen}" style="float: right; font-size: 1.5em;"></i></button>
        <div class="content" [ngClass]="{'active': batchEditOpen}">  
          <app-batch-edit-pane [imageType]="getImageType()" [imageModels]="[]" (closeEmitter)="closeBatchEdit()" (processCompleteEmitter)="batchEditConfirmed($event)" style="margin-top: 3em;"></app-batch-edit-pane>
        </div>
      </div>
      <div *ngIf="!working && step1Ready && step2Ready">
        <h6>Step 5: Choose images to upload</h6>
        <div class="custom-file">
          <input [disabled]="this.working" id="imageFilesButton" type="file" #imageFiles class="custom-file-input"
            (change)="handleFileInput($event, imageFiles.files)" value="Select Files"
            accept=".png,.jpg,.jpeg,.tiff,.tif,.gif" multiple>
          <label for="imageFilesButton" class="custom-file-label">
            <i class="fa-lg fal fa-images"></i> Choose {{type}}
          </label>
        </div>
      </div>
      <div class="mt-2 message" [ngClass]="messageBadgeClass" *ngIf="message">
        <i class="fal me-1" [ngClass]="messageIconClass"></i>
        {{ message }}
      </div>
      <div style="display: inline-block;" *ngIf="errors && !working">
        <input type="button" class="btn btn-dark ms-1" value="Clear" (click)="clear()">
      </div>
    </form>

    <div class="progress" *ngIf="working">
      <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="0"
        aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': progressPercent + '%'}"></div>
    </div>
    <div style="display: inline-block;" *ngIf="working">
      <input type="button" class="btn btn-warning" value="Cancel" (click)="cancelJob()">
    </div>
    <hr>
    <div class="tableHolder">
      <table class="mb-2 table" *ngIf="attachments.length > 0">
        <thead>
          <tr>
            <th>Filename </th>
            <th> Filesize </th>
            <th colspan="2"> Status</th>
          </tr>
        </thead>
        <tr class="uploadItem" *ngFor="let item of attachments.slice().reverse()">
          <td>{{ item.file.name }}</td>
          <td>{{ item.file.size/1024 | number }} Kb</td>
          <td>{{ item.status }}</td>
          <td><i class="fal fa-lg fa-fw" 
            [ngClass]="{
              'fa-check': item.status === FILE_DONE,
              'fa-exclamation-triangle': item.status === FILE_CANCELED,
              'fa-exclamation-circle': item.status.includes(FILE_ERROR),
              'fa-hourglass': item.status === FILE_WAITING,
              'fa-cloud-upload': item.status === FILE_UPLOADING
            }">
              </i>
          </td>
        </tr>
      </table>

      <lib-table-editor *ngIf="showingLogs" [sortEnabled]="false" [filtersEnabled]=false [paginationOn]="true" [tableTitle]="'Batch Logs'" [isAdmin]="false" [rpp]="10" [tableData]="batchLogs" [columnsData]="batchLogColumnData">
      </lib-table-editor>
    </div>

    <app-slant-button btnColor="white" (click)="showBatchLogs()" btnIconClass="fa-list-ol">View/hide upload logs</app-slant-button>
  </div>
</div>
